import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { DefaultEntityService } from '@mri-platform/shared/entity';
import { DefaultDataServiceConfig } from '@ngrx/data';
import { tap } from 'rxjs';
import { ClientSummary } from '../models/client-summary';

@Injectable({ providedIn: 'root' })
export class ClientSummaryEntityService extends DefaultEntityService<ClientSummary> {
  constructor(
    injector: Injector,
    private http: HttpClient,
    private apiConfig: DefaultDataServiceConfig
  ) {
    super(ClientSummary.entityName, injector);
  }

  get$() {
    this.setLoading(true);
    return this.http
      .get<ClientSummary>(`${this.apiConfig.root}/clientsummaries`)
      .pipe(tap(_ => this.setLoading(false)));
  }
}
